import React from 'react';

import { TrelloIcon } from '@atlaskit/logo/trello-icon';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <TrelloIcon size="xsmall" label="" />;

export const useTrello = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.TRELLO,
		analyticsName: Products.TRELLO,
		...options,
	});
